import { render, staticRenderFns } from "./DesignerIconMenu.vue?vue&type=template&id=45f6be5b&scoped=true&"
import script from "./DesignerIconMenu.vue?vue&type=script&lang=ts&"
export * from "./DesignerIconMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DesignerIconMenu.vue?vue&type=style&index=0&id=45f6be5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f6be5b",
  null
  
)

export default component.exports